<template>
  <div class="view-site-inspection-dialog">
    <v-card>
      <v-card-title>{{ item.name }} 점검기록</v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col>
              <v-text-field
                v-model="item.title"
                label="제목"
                type="text"
                readonly
                required/>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              최초 작성 시각 {{ getTimestampString(item.createdTimestamp) }}
            </v-col>
            <v-col>
              최종 수정 시각 {{ getTimestampString(item.editedTimestamp) }}
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-textarea
                v-model="item.contents"
                label="내용"
                required
                readonly
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn text @click="dialog.viewInspectionDialog = false">확인</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
  import moment from 'moment'

  export default {
    name: 'viewInspectionDialog',
    props: {
      dialog: {
        type: Object,
        required: true
      },
      item: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
      }
    },
    methods: {
      getTimestampString(timestamp) {
        if (!timestamp) {
          return '없음';
        }

        return moment(timestamp).format('YYYY-MM-DD HH:mm:ss');
      },
      printDebugLog(target) {
        console.dir(target);
      },
      popupAlert(message, color) {
        this.$bus.$emit('popupAlert', {message: message, color: color});
      }
    },
    mounted() {
    }
  }
</script>